import { Patient } from "@/Common/Models/Patient/Patient";
import { MedicalItemVitalSign } from "@/Patient/Models/MedicalSummary/MedicalItemVitalSign";
import { ObstetricalCounters } from "@/Patient/Models/MedicalSummary/ObstetricalSummary";
import { MedicalItemScreeningTestResponse } from "@/Patient/Models/MedicalSummary/Response/MedicalItemScreeningTestResponse";
import { BaseObstetricalFileForm, ObstetricFormContext } from "@/Patient/Models/ObstetricalFile/BaseObstetricalFileForm";
import { BaseObstetricalFileModel } from "@/Patient/Models/ObstetricalFile/BaseObstetricalFileModel";

interface ObstetricalFileParams {
    obstetricFormContext: ObstetricFormContext,
    patient?: Patient,
    consultationDate?: Date,
    previousObstetricalFile?: BaseObstetricalFileModel,
    obstetricalCounters?: ObstetricalCounters,
    vitalSigns: MedicalItemVitalSign[],
    latestPapTest?: MedicalItemScreeningTestResponse
}

abstract class BaseObstetricalFormCreator {
    public abstract createObstetricalFileForm(params: ObstetricalFileParams): BaseObstetricalFileForm;

    protected createObstetricalCounters(obstetricalCounters: ObstetricalCounters): ObstetricalCounters {
        obstetricalCounters.Gravida = (obstetricalCounters?.Gravida ?? 0) + 1;

        return obstetricalCounters;
    }
}

export { BaseObstetricalFormCreator, ObstetricalFileParams };
